import { Component, Input, OnInit } from '@angular/core';
import { RegistroPrecos } from 'eddydata-lib';
import { BaseLicitacaoAudesp } from '../../util/base-licitacao-audesp';
//import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-edital-fase2',
  templateUrl: './licitacao-audesp-edital-fase2.component.html'
})
export class LicitacaoAudespEditalFase2Component extends BaseLicitacaoAudesp implements OnInit {

  @Input() public entidade: RegistroPrecos;

  constructor(
  ) {
    super()
  }

  ngOnInit(): void {
  }

}
